import { queryOptions } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";
import type { PowerUpServiceResponseBody } from "@vendata/power-up-spec";

export async function fetchOrganizationById(
  id: string,
): Promise<PowerUpServiceResponseBody["getOrganizationById"][200]> {
  return handleClientMethod(
    getClient().GET("/organizations/{id}", {
      params: { path: { id } },
    }),
  );
}

export const getOrganizationByIdQuery = (id: string) => {
  return queryOptions({
    queryKey: ["organizations", "get-by-id", id],
    queryFn: () => fetchOrganizationById(id),
  });
};
